__turbopack_context__.v({
  "columnContainer": "Cb6qqG_columnContainer",
  "componentContainer": "Cb6qqG_componentContainer",
  "container": "Cb6qqG_container",
  "contentInner": "Cb6qqG_contentInner",
  "contentWrapper": "Cb6qqG_contentWrapper",
  "copy": "Cb6qqG_copy",
  "detailsContainer": "Cb6qqG_detailsContainer",
  "dropdownContainer": "Cb6qqG_dropdownContainer",
  "dropdownIconContainer": "Cb6qqG_dropdownIconContainer",
  "factContainer": "Cb6qqG_factContainer",
  "list": "Cb6qqG_list",
  "propertyDetailsWrapper": "Cb6qqG_propertyDetailsWrapper",
  "section": "Cb6qqG_section",
});
